import * as e from "react";
const a = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.621 3.979L15.3 2.3a1 1 0 011.4 0l3 3a1 1 0 010 1.4l-1.07 1.068a486.787 486.787 0 00-.533.531L13.62 3.98zm3.42 5.38L8.7 17.7a1 1 0 01-.7.3H5a1 1 0 01-1-1v-3a1 1 0 01.3-.7l8.233-8.233L17.04 9.36zm-4.474-1.498l1.61 1.534L7.572 16H6v-1.572l6.567-6.567zM22 21a1 1 0 00-1-1H3a1 1 0 100 2h18a1 1 0 001-1z",
      fill: "#2d6ded"
    }
  )
);
export {
  a as default
};
